import { createSelector } from '@ngrx/store';
import { roleFeatureKey } from '../reducers/role.reducers';

export const getRole = createSelector(
  (state: any) => state[roleFeatureKey],
  (roleState: any) => roleState?.role ?? null,
);

export const getEntityRoles = createSelector(
  (state: any) => state[roleFeatureKey],
  (roleState: any) => roleState.entityRoles,
);

export const getEntityRole = (entityId: string) =>
  createSelector(getEntityRoles, (enitityRoles: any) => enitityRoles[entityId]);

export const getRolePermissions = createSelector(
  (state: any) => state[roleFeatureKey],
  (roleState: any) => roleState.rolePermissions,
);

export const getRolePermission = (roleId: string) =>
  createSelector(
    getRolePermissions,
    (rolePermissions: any) => rolePermissions[roleId],
  );

export const loadingRolePermissions = (roleId: string) =>
  createSelector(
    (state: any) => state[roleFeatureKey],
    (roleState: any) => roleState.loading[roleId],
  );
